/**
 * Created by desheng.zhao on 2019/2/21.
 */

// 按页面划分
export default {
  // 公共页面
  common: {
    fill: "請填寫",
    fillError: "填寫錯誤",
    fillHasError: "表單填寫不完整",
    ajaxError: "數據出錯了",
    networkError: "網絡出錯了~",
    tokenExpire: "登錄信息已失效或未登錄",
  },
  //邮箱登录
  emailLogin: {
    title: '登錄',
    subTitle: "郵箱登錄",
    emailAccount: "郵箱",
    password: "密碼",
    emailEmpty: "請填寫郵箱",
    emailError: "郵箱填寫錯誤",
    checkEmail: "請檢查郵箱",
  },
  // 登录
  login: {
    title: "登錄",
    subTitle: "手機登錄",
    phoneNo: "手機號",
    password: "密碼",
    msgCode: "驗證碼",
    getMsgCode: "獲取驗證碼",
    getMsgInterval: "s后可重新獲取", // 这里的s是秒的意思
    loginBtn: "登錄",
    registerBtn: "註冊",
    resetBtn: "忘記密碼",
    phoneEmpty: "請填寫手機會好",
    phoneError: "手機號填寫錯誤",
    checkPhone: "請檢查手機號",
    fillMsgCode: "請填寫手機驗證碼",
    fillPassword: "請填寫密碼",
    fill: "請填寫",
    fillError: "填寫錯誤",
    hasError: "表單填寫不完整或有誤",
    loginSuccess: "登錄成功",
    needMsgCheck: "本次登錄需要短信驗證碼驗證",
  },
  // 注册
  register: {
    title: "註冊",
    subTitle: "手機註冊",
    phoneNo: "手機號碼",
    password: "設置6-20位密碼",
    repeatPwd: "再次確認密碼",
    msgCode: "驗證碼",
    getMsgCode: "獲取驗證碼",
    getMsgInterval: "s后可重新獲取", // 这里的s是秒的意思
    picCode: "請輸入圖片驗證碼",
    getPicCode: "獲取圖片驗證碼",
    registerBtn: "註冊",
    auth: {
      tip: "註冊即表示您已閱讀并同意",
      agreeMent: "用戶協議",
      and: "和",
      policy: "隱私政策"
    },
    footer: "如有疑問，可在公眾號中反饋",

    phoneEmpty: "請填寫手機號",
    phoneError: "手機號填寫錯誤",
    fillPassword: "請填寫密碼",
    pwdInvalidLetter: "密碼中包含不合法的符號号",
    pwdLenLow: "密碼不可小於6位",
    pwdNeedLetter: "密碼需包含字母或特殊符號",
    pwdNeedNum: "密碼需包含數字",
    pwdLenUp: "密碼長度超過最大20位限制",
    fillRepeatPwd: "請填寫確認密碼",
    RepeatPwdError: "兩次密碼不一致致",
    fillMsgCode: "請填寫手機驗證碼",
    fillPicCode: "請填寫圖片驗證碼",
    getPicCodeFirst: "請先獲取圖片驗證碼",
    registSuccess: "註冊成功",
  },
  // 找回密码
  reset: { // 找回密码很多字段和注册一样，就直接调用注册的
    title: "重置密碼",
    subTitle: "重置密碼",
    resetBtn: "確認修改并登錄",
  },
  // 登录成功
  loginSuccess: {
    title: "登錄成功",
    logAccount: "賬號已登錄",
    toBindBtn: "去綁定設備",
    toShareBtn: "去分享流量",
    logOutBtn: "退出賬號",
    footer: "若無設備，請聯繫公眾號客服",

    isLogout: "是否要退出當前賬號？",
    confirmText: "確定",
    cancelText: "取消",
    logOutSuccess: "退出賬號成功",
  },
  // 绑定设备
  binding: {
    title: "綁定設備",
    imei: "設備編碼：",
    fillImei: "請輸入設備IMMEI號号",
    password: "設備密碼：",
    fillPwd: "請輸入設備密碼",
    bindBtn: "立即綁定",
    needImei: "請填寫設備編碼",
    needPwd: "請填寫設備密碼",
  },
  // 绑定设备成功
  binded: {
    title: "綁定成功",
    bindedMachine: "已綁定設備",
    toShare: "去分享卡流量",
    unbind: "解除綁定",
    unbindSuccess: "解除綁定成功",
    isUnbind: "是否要解除設備綁定？",
    confirmText: "確定",
    cancelText: "取消",
  },
  // 卡分享详情
  shareDetail: {
    title: "卡分享詳情",
    imei: "設備號",
    online: "在線",
    offline: "離線",
    tip: "溫馨提示",
    footer: "如有疑問，請聯繫公眾號客服解決",
    submitSuccessTip: "提交申請成功，客服將盡快給您審核派單，請您稍等一下，派單后需要您再次確認哦~",
    alertButtonText: "確定",
    offlineOperateTip: "設備離線狀態下不可以操作哦~",
    offlineTip: "您的設備已離線，請檢查設備狀態，離線將影響您的卡分享收益，如有疑問，請添加一下QQ群聯繫客服解決。",
    unbindedTip: "此設備已被解綁，請重新綁定",
    cancelSuccess: "取消成功",

    simShareInfo: { // sim-share-info
      simShareInfo: "卡分享信息",
      phone: "號碼",
      flow: "分享流量",
      price: "單價",
      shareEndTime: "分享日期至",
      cancelShareBtn: "取消分享",
      confirmShareBtn: "確認分享",
    },

    simShareSuccess: {
      shareSuccess: "分享成功",
      tip: "分享期間請保持設備的開啟狀態，保證穩定供卡",
      alertBtnText: "確定"
    },

    submitSimInfo: {
      title: "填寫分享卡的套餐信息",
      phone: "號碼",
      phonePh: "請輸入SIM卡的號碼", // ph  placeholder
      flow: "分享流量",
      flowPh: "建議{flow}GB以下",
      flowPh1: "建議",
      flowPh2: "GB以下",
      shareEndTime: "分享日期至",
      shareEndTimePh: "分享結束日期",

      operator: "運營商",
      operatorPh: "選擇運營商",
      pickerConfirmText: "確定",
      pickerCancelText: "取消",

      cancelBtn: "取消",
      submitBtn: "提交",

      needPhone: "請填寫手機號",
      phoneError: "手機號填寫錯誤",
      needFlow: "請填寫分享流量額度",
      flowTip: "分享流量請輸入{flow}以內的整數",
      flow1: "分享流量請輸入",
      flow2: "以内的整數",
      flowCannot0: "分享流量不能為0",
      flowCannotMinus: "分享流量不能為負數",
      fillShareEndTime: "請填寫分享截止時間",
      selectOperator: "請選擇運營商",
    },

    oneSim: {
      dataError: "數據異常，",
      tryAgain: "刷新試試",
      loading: "加載中……",
      detectedSim: "檢測到SIM卡",
      toShare: "去分享",
      detectedNoSim: "未檢測到SIM卡",
      enterSim: "請插入SIM卡",
      status00: "等待分享",
      status01: "審核中",
      status02: "已配單，確認分享",
      status03: "審核失敗,重新分享",
      status04: "正在分享",
      status05: "分享中斷",
      status06: "重新分享",
      status07: "取消分享",
      status08: "卡業務狀態異常",
    }
  },
  // 提现记录
  withdrawRecord: {
    title: "提現記錄",
    totalProfit: "總收益",
    canWithdrawAmount: "可提現(元)",
    withdraw: "提現",
    withdrawRecord: "提現記錄",
    withdrawAmount: "提現金額",
    moreRecord: "查看更多",
    noMoreData: "Sorry，沒有新的數據哦",
    footer: "如有疑問，請聯繫公眾號客服解決",
    cannotWithdraw: "您還未有分享的流量，趕緊去分享吧",
    noRecord: "您還沒有提現記錄哦~",
    contactMe: "請關注插卡寶公眾號或者聯繫qq客服738605106"
  },
  // 提现
  withdraw: {
    title: "提現",
    canWithdrawAmountTip: "可提現金額(元)",
    withdrawPre: "￥",
    amountPh: "請輸入要提現的金額",
    canWithdrawAmount: "可提現金額{amount}元",
    withdrawAll: "全部提現",
    withdrawTo: "提現到",
    wechatWallet: "微信錢包",
    sendMethod: "客服紅包發放",
    nameConfirm: "身份核對：",
    namePh: "請輸入您的真實姓名名",
    withdrawBtn: "提現",
    tip: "客服給您打款的日期為每週五11:00~18:00（國家法定節假日除外）",
    footer: "如有疑問，請聯繫公眾號客服解決",

    needName: "請輸入您的真實姓名",
    withdrawTip: "客服已收到您的提現需求，我們將在週五給您打款。您可以加入以下QQ群尋求幫助{QQ}",
    alertButtonText: "確定",
    needAmount: "請填寫提現金額",
    amountIsNaN: "提現金額只能輸入數字字",
    amountLg: "提現金額不可以大於可提現金額",
    twoDecimalPlaces: "最多支持兩位小數数",
    amountNegative: "提現金額不能為負數",
    amountIs0: "提現金額不能為0",
    usernameError: "姓名格式錯誤"
  },
  // 历史订单
  historyOrders: {
    title: "歷史訂單",
    createOrderTime: "訂單時間",
    sharedFlow: "分享流量",
    moreOrder: "查看更多",
    noMoreData: "Sorry，沒有新的數據哦",
    footer: "如有疑問，請聯繫公眾號客服解决",
    noOrder: "您還未有完成訂單哦，不要著急",
  },
  // 订单详情
  orderDetail: {
    title: "歷史訂單",
    phone: "手機號碼",
    flow: "分享流量",
    createOrderTime: "訂單時間",
    price: "價格規則",
    orderId: "訂單單號",
    footer: "如有疑問，請聯繫公眾號客服解决",
  },
  // 无设备
  noSim: {
    title: "卡分享詳情",
    noCard: "還沒有分享的流量卡哦~",
    toBind: "已有設備，去綁定",
    footer: "若無設備，請聯繫公眾號客服",
  },
  // 设置
  setting: {
    title: "設置",
    device: "我的設備",
    language: "切換語言",
    logOut: "退出賬號"
  },
  // 切换语言
  changeLanguage: {
    title: "切換語言"
  },
  // 隐私政策
  policy: {
    title: "隱私政策"
  },
  // 切换语言
  agreement: {
    title: "用戶協議"
  },
  // 首页
  home: {
    title: "插卡寶",
    totalFit: "總收益金額",
    withdraw: "提現",
    withdrawHistory: "收益記錄",
    historyOrder: "歷史訂單",
    instruction: "使用說明",
    myDevices: "我的設備",
    boxName: "SIM卡盒子",
    online: "在線",
    offline: "離線",
    imeiNum: "IMEI號",
    addDevice: "掃碼添加設備",
    noDevice: "還沒有綁定設備哦~",
    noFit: "暫無收益",
    noSignal: "無信號",
    profitUnit: "元",
    unknownPhone: "未識別您的機型",
    openInApp: "請在多卡寳APP中使用此功能"
  },
  reservationCode: {
    title: "插卡寶",
    inputCodeTip: "請輸入您的預約碼",
    noCode: "若您沒有預約碼請聯繫客服",
    codePlaceholder: "請輸入您的預約碼",
    btnText: "確定",
    auth: {
      tip: "確定即表示您已閱讀并同意",
      agreeMent: "用戶協議",
      and: "和",
      policy: "隱私政策"
    },
    validateSuccess: "驗證成功",
  },
  // 使用说明
  instruction: {
    title: "使用說明",
    step1: "1、進入APP內，個人-SIM卡設置，選擇“共享SIM卡”；",
    step1Remark: "(注：此時SIM卡將被設置為雲卡，SIM卡設置為雲卡后無法使用語音、短息等服務，在提交訂單前可隨時取消此狀態。)",
    step2: "2、點擊“立即申請”或在【個人】頁面內點擊“流量交易”，進入可提交訂單；",
    step3: "3、【流量交易】內，可將此前所設置的SIM卡進行提交訂單申請，待訂單審核通過后可查看此前交易狀態、金額等信息。",
    readBtn: "好的，知道了",
  },
  // 所有的过渡页面
  pages: {
    userCenter: "個人中心",
    myMachine: "我的設備"
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-TW.js